module.exports = __webpack_public_path__ + "static/img/25-Sunderland-regeneration.4d19b4c8.jpg";